import { render } from "./ForgetPasswordReset.vue?vue&type=template&id=7304e5e2&scoped=true&ts=true"
import script from "./ForgetPasswordReset.vue?vue&type=script&lang=ts"
export * from "./ForgetPasswordReset.vue?vue&type=script&lang=ts"

import "./ForgetPasswordReset.vue?vue&type=style&index=0&id=7304e5e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7304e5e2"]])

export default __exports__